/* eslint no-underscore-dangle: 0 */
// dependencies
import { List, Map, fromJS } from "immutable";
import moment from "moment";

// constants
import Lifecycle from "../constants/APILifecycle";

const initialState = Map({
	feedback: Map(),
	lists: Map(),
});

export default function invitation(state = initialState, action) {
	/*
        state.feedback will be a map of all feedback
        state.lists will contain lists of feedback IDs nested in userId, view.

        * so lists = { userid: { view: [] }
    */

	switch (action.type) {
		case "FEEDBACK:SET": {
			const { feedback } = action;

			return state.setIn(["feedback", feedback.get("_id")], feedback);
		}

		case "FEEDBACK:PARSE_RESPONSE": {
			const feedbackIds = action.data.items.map((feedback) => feedback._id);

			return state.withMutations((nest) => {
				// feeback id list
				nest.setIn(["lists", action.userId, action.view], List(feedbackIds));
				nest.setIn(["count"], action.data.count);

				// feedback map
				action.data.items.forEach((feedback) => {
					// deconstruct
					let feedbackObject = feedback;

					// collect user objects
					const _userObjects = {
						[feedbackObject.author_object._id]: feedbackObject.author_object,
					};
					feedbackObject.subjects_list.forEach((u) => {
						_userObjects[u._id] = u;
					});

					feedbackObject._userObjects = _userObjects;

					// make immutable
					feedbackObject = fromJS(feedbackObject);

					// momentize the date
					feedbackObject = feedbackObject.set("last_updated", moment(feedbackObject.get("last_updated")));

					nest.setIn(["feedback", feedbackObject.get("_id")], feedbackObject);
				});
			});
		}

		case `FEEDBACK:DELETE@${Lifecycle.get("success")}`: {
			const view = null;
			const userId = null;
			const { feedbackId } = action;

			return state.withMutations((nest) => {
				nest.setIn(
					["lists", userId, view],
					nest.get("lists").filter((fid) => fid !== feedbackId)
				);
				nest.setIn(["feedback", feedbackId], "deleted");
			});
		}

		default:
			// never forget your default return state!
			return state;
	}
}
